module.exports = __webpack_public_path__ + "assets/images/Caixa_parabens_4aa6ec0b8747442563ae18249b4ba0cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-eight/Caixa_parabens.png
// module id = 241
// module chunks = 0